export const UPDATE_EMAIL_FULL_NAME = 'UPDATE_EMAIL_FULL_NAME';

export const updateEmailFullName = (user, errorMsg) => ({ type: UPDATE_EMAIL_FULL_NAME, payload: user, meta: { errorMsg } });
